import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const lessonImporterSelectors = importerSelectors(
  'lesson.importer',
)

export default lessonImporterSelectors
